const STORAGE_KEY = 'personal-hangar:view-mode';
const VALID_MODES = new Set(['card', 'list']);

export function readHangarViewMode() {
  if (typeof window === 'undefined') return 'card';

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return VALID_MODES.has(raw) ? raw : 'card';
  } catch {
    return 'card';
  }
}

export function writeHangarViewMode(mode) {
  if (typeof window === 'undefined') return;
  if (!VALID_MODES.has(mode)) return;

  try {
    window.localStorage.setItem(STORAGE_KEY, mode);
  } catch {
    // ignore quota / private mode errors
  }
}
